// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gray {
  color: #292727;
}

.layered {
  box-shadow: 0 1rem 2rem rgba(0, 0, 0, 0.19), 0 0.6rem 0.6rem rgba(0, 0, 0, 0.23);
}

.layered-no-overlap, .react-modal-overlay.event-action-modal .react-modal,
.event-confirmation .react-modal,
.snooze-popup .react-modal,
.repeat-rule-popup .react-modal,
.repeat-options-modal .react-modal,
.jump-popup .react-modal {
  box-shadow: 0 1rem 1rem rgba(0, 0, 0, 0.19), 0 0.6rem 0.6rem rgba(0, 0, 0, 0.23);
}

.no-gutter > [class*=col-] {
  padding-right: 0;
  padding-left: 0;
}

.event-modal .modal-header {
  font-size: 2em;
}
.event-modal .event-address {
  width: 100%;
}
.event-modal .event-address input {
  width: 100%;
}
.event-modal > .row:not(:first-child), .event-modal > .flex-row:not(:first-child) {
  margin-top: 0.5rem;
}
.event-modal > .row:first-child, .event-modal > .flex-row:first-child {
  margin-bottom: 1rem;
}
.event-modal label[for=description] {
  margin-top: 0.7rem;
}
.event-modal .description.ql-container {
  height: 7.5rem;
  overflow-y: auto;
}
.event-modal .description.ql-container .ql-editor {
  padding: 0;
}
@media (min-width: 768px) {
  .event-modal {
    min-height: 33.5rem;
  }
}

.react-modal-overlay.event-action-modal,
.event-confirmation,
.snooze-popup,
.repeat-rule-popup,
.repeat-options-modal,
.jump-popup {
  display: flex;
  align-items: center;
  justify-content: space-around;
}
.react-modal-overlay.event-action-modal span.react-modal-close,
.event-confirmation span.react-modal-close,
.snooze-popup span.react-modal-close,
.repeat-rule-popup span.react-modal-close,
.repeat-options-modal span.react-modal-close,
.jump-popup span.react-modal-close {
  height: 1.5rem;
  right: 1rem;
}
@media (max-width: 768px) {
  .react-modal-overlay.event-action-modal span.react-modal-close,
  .event-confirmation span.react-modal-close,
  .snooze-popup span.react-modal-close,
  .repeat-rule-popup span.react-modal-close,
  .repeat-options-modal span.react-modal-close,
  .jump-popup span.react-modal-close {
    font-size: 1.6rem;
    top: 0;
    right: 0;
    margin-bottom: 0;
    padding: 0.8rem 0.8rem 0.8rem 0.8rem;
    height: 3rem;
  }
}
.react-modal-overlay.event-action-modal .react-modal,
.event-confirmation .react-modal,
.snooze-popup .react-modal,
.repeat-rule-popup .react-modal,
.repeat-options-modal .react-modal,
.jump-popup .react-modal {
  color: #fff;
  padding: 0 0.5rem 2rem 0.5rem;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border-color: #696969;
}
@media (min-width: 600px) {
  .react-modal-overlay.event-action-modal .react-modal,
  .event-confirmation .react-modal,
  .snooze-popup .react-modal,
  .repeat-rule-popup .react-modal,
  .repeat-options-modal .react-modal,
  .jump-popup .react-modal {
    padding: 0;
    width: 50rem;
    top: unset;
    bottom: unset;
    left: unset;
    right: unset;
    max-height: 100%;
  }
}
.react-modal-overlay.event-action-modal .react-modal .clone-btn.btn.btn-default,
.event-confirmation .react-modal .clone-btn.btn.btn-default,
.snooze-popup .react-modal .clone-btn.btn.btn-default,
.repeat-rule-popup .react-modal .clone-btn.btn.btn-default,
.repeat-options-modal .react-modal .clone-btn.btn.btn-default,
.jump-popup .react-modal .clone-btn.btn.btn-default {
  padding: 0.6rem 1.2rem;
  margin: -0.6rem 0.6rem;
  min-width: unset;
  color: #292727;
}
@media (max-width: 768px) {
  .react-modal-overlay.event-action-modal .react-modal .clone-btn.btn.btn-default,
  .event-confirmation .react-modal .clone-btn.btn.btn-default,
  .snooze-popup .react-modal .clone-btn.btn.btn-default,
  .repeat-rule-popup .react-modal .clone-btn.btn.btn-default,
  .repeat-options-modal .react-modal .clone-btn.btn.btn-default,
  .jump-popup .react-modal .clone-btn.btn.btn-default {
    font-size: 1.6rem;
    margin: 0.3rem 0.6rem -0.3rem;
  }
}
.react-modal-overlay.event-action-modal .react-modal .react-modal-content,
.event-confirmation .react-modal .react-modal-content,
.snooze-popup .react-modal .react-modal-content,
.repeat-rule-popup .react-modal .react-modal-content,
.repeat-options-modal .react-modal .react-modal-content,
.jump-popup .react-modal .react-modal-content {
  color: #696969;
}
.react-modal-overlay.event-action-modal .react-modal .react-modal-content label,
.react-modal-overlay.event-action-modal .react-modal .react-modal-content .label,
.event-confirmation .react-modal .react-modal-content label,
.event-confirmation .react-modal .react-modal-content .label,
.snooze-popup .react-modal .react-modal-content label,
.snooze-popup .react-modal .react-modal-content .label,
.repeat-rule-popup .react-modal .react-modal-content label,
.repeat-rule-popup .react-modal .react-modal-content .label,
.repeat-options-modal .react-modal .react-modal-content label,
.repeat-options-modal .react-modal .react-modal-content .label,
.jump-popup .react-modal .react-modal-content label,
.jump-popup .react-modal .react-modal-content .label {
  font-weight: 100;
  -webkit-font-smoothing: subpixel-antialiased;
}
.react-modal-overlay.event-action-modal label,
.react-modal-overlay.event-action-modal .label,
.event-confirmation label,
.event-confirmation .label,
.snooze-popup label,
.snooze-popup .label,
.repeat-rule-popup label,
.repeat-rule-popup .label,
.repeat-options-modal label,
.repeat-options-modal .label,
.jump-popup label,
.jump-popup .label {
  white-space: nowrap;
  font-size: 1.2rem;
  color: #696969;
}
.react-modal-overlay.event-action-modal label.manage-alarms-label,
.react-modal-overlay.event-action-modal .label.manage-alarms-label,
.event-confirmation label.manage-alarms-label,
.event-confirmation .label.manage-alarms-label,
.snooze-popup label.manage-alarms-label,
.snooze-popup .label.manage-alarms-label,
.repeat-rule-popup label.manage-alarms-label,
.repeat-rule-popup .label.manage-alarms-label,
.repeat-options-modal label.manage-alarms-label,
.repeat-options-modal .label.manage-alarms-label,
.jump-popup label.manage-alarms-label,
.jump-popup .label.manage-alarms-label {
  padding-top: 1.5rem;
}
.react-modal-overlay.event-action-modal .color-picker-wrapper,
.event-confirmation .color-picker-wrapper,
.snooze-popup .color-picker-wrapper,
.repeat-rule-popup .color-picker-wrapper,
.repeat-options-modal .color-picker-wrapper,
.jump-popup .color-picker-wrapper {
  position: absolute;
  right: 1rem;
  top: 3rem;
}
@media (max-width: 768px) {
  .react-modal-overlay.event-action-modal .color-picker-wrapper,
  .event-confirmation .color-picker-wrapper,
  .snooze-popup .color-picker-wrapper,
  .repeat-rule-popup .color-picker-wrapper,
  .repeat-options-modal .color-picker-wrapper,
  .jump-popup .color-picker-wrapper {
    top: 3.6rem;
  }
}
.react-modal-overlay.event-action-modal .react-select,
.event-confirmation .react-select,
.snooze-popup .react-select,
.repeat-rule-popup .react-select,
.repeat-options-modal .react-select,
.jump-popup .react-select {
  font-size: 1.2rem;
}
.react-modal-overlay.event-action-modal .minimal-input,
.event-confirmation .minimal-input,
.snooze-popup .minimal-input,
.repeat-rule-popup .minimal-input,
.repeat-options-modal .minimal-input,
.jump-popup .minimal-input {
  padding-left: 0;
  padding-right: 0;
  padding: 0;
  height: auto;
}
.react-modal-overlay.event-action-modal .form-control,
.event-confirmation .form-control,
.snooze-popup .form-control,
.repeat-rule-popup .form-control,
.repeat-options-modal .form-control,
.jump-popup .form-control {
  color: #292727;
}
.react-modal-overlay.event-action-modal .form-group,
.event-confirmation .form-group,
.snooze-popup .form-group,
.repeat-rule-popup .form-group,
.repeat-options-modal .form-group,
.jump-popup .form-group {
  margin: 0;
}
.react-modal-overlay.event-action-modal .event-label input,
.event-confirmation .event-label input,
.snooze-popup .event-label input,
.repeat-rule-popup .event-label input,
.repeat-options-modal .event-label input,
.jump-popup .event-label input {
  margin-top: 1rem;
  font-size: 1.8rem;
}
.react-modal-overlay.event-action-modal .margin-top,
.event-confirmation .margin-top,
.snooze-popup .margin-top,
.repeat-rule-popup .margin-top,
.repeat-options-modal .margin-top,
.jump-popup .margin-top {
  margin-top: 2rem !important;
}
.react-modal-overlay.event-action-modal .half-margin-top,
.event-confirmation .half-margin-top,
.snooze-popup .half-margin-top,
.repeat-rule-popup .half-margin-top,
.repeat-options-modal .half-margin-top,
.jump-popup .half-margin-top {
  margin-top: 1rem;
}
.react-modal-overlay.event-action-modal .half-margin-bottom,
.event-confirmation .half-margin-bottom,
.snooze-popup .half-margin-bottom,
.repeat-rule-popup .half-margin-bottom,
.repeat-options-modal .half-margin-bottom,
.jump-popup .half-margin-bottom {
  margin-bottom: 1rem;
}
.react-modal-overlay.event-action-modal .no-margin-left,
.event-confirmation .no-margin-left,
.snooze-popup .no-margin-left,
.repeat-rule-popup .no-margin-left,
.repeat-options-modal .no-margin-left,
.jump-popup .no-margin-left {
  margin-left: 0;
}
.react-modal-overlay.event-action-modal .btn-default,
.event-confirmation .btn-default,
.snooze-popup .btn-default,
.repeat-rule-popup .btn-default,
.repeat-options-modal .btn-default,
.jump-popup .btn-default {
  min-width: 12rem;
  border: 0;
  background: 0;
  border-radius: 0;
  color: #696969;
}
.react-modal-overlay.event-action-modal .Select-value,
.event-confirmation .Select-value,
.snooze-popup .Select-value,
.repeat-rule-popup .Select-value,
.repeat-options-modal .Select-value,
.jump-popup .Select-value {
  padding: 0;
}
.react-modal-overlay.event-action-modal .calendar-timezone-area label,
.event-confirmation .calendar-timezone-area label,
.snooze-popup .calendar-timezone-area label,
.repeat-rule-popup .calendar-timezone-area label,
.repeat-options-modal .calendar-timezone-area label,
.jump-popup .calendar-timezone-area label {
  min-width: 6.5rem;
}
.react-modal-overlay.event-action-modal .calendar-timezone-area .Select-value,
.event-confirmation .calendar-timezone-area .Select-value,
.snooze-popup .calendar-timezone-area .Select-value,
.repeat-rule-popup .calendar-timezone-area .Select-value,
.repeat-options-modal .calendar-timezone-area .Select-value,
.jump-popup .calendar-timezone-area .Select-value {
  max-width: calc(100% - 2rem);
}
.react-modal-overlay.event-action-modal textarea,
.event-confirmation textarea,
.snooze-popup textarea,
.repeat-rule-popup textarea,
.repeat-options-modal textarea,
.jump-popup textarea {
  width: 100%;
}
.react-modal-overlay.event-action-modal .repeat-right-values .flex-row,
.event-confirmation .repeat-right-values .flex-row,
.snooze-popup .repeat-right-values .flex-row,
.repeat-rule-popup .repeat-right-values .flex-row,
.repeat-options-modal .repeat-right-values .flex-row,
.jump-popup .repeat-right-values .flex-row {
  min-height: 2.1rem;
}
.react-modal-overlay.event-action-modal .repeat-right-values input[type=checkbox] + label,
.react-modal-overlay.event-action-modal .repeat-right-values .label,
.react-modal-overlay.event-action-modal .repeat-right-values label,
.event-confirmation .repeat-right-values input[type=checkbox] + label,
.event-confirmation .repeat-right-values .label,
.event-confirmation .repeat-right-values label,
.snooze-popup .repeat-right-values input[type=checkbox] + label,
.snooze-popup .repeat-right-values .label,
.snooze-popup .repeat-right-values label,
.repeat-rule-popup .repeat-right-values input[type=checkbox] + label,
.repeat-rule-popup .repeat-right-values .label,
.repeat-rule-popup .repeat-right-values label,
.repeat-options-modal .repeat-right-values input[type=checkbox] + label,
.repeat-options-modal .repeat-right-values .label,
.repeat-options-modal .repeat-right-values label,
.jump-popup .repeat-right-values input[type=checkbox] + label,
.jump-popup .repeat-right-values .label,
.jump-popup .repeat-right-values label {
  line-height: 2.1rem;
}
.react-modal-overlay.event-action-modal .repeat-right-values input[name=count],
.event-confirmation .repeat-right-values input[name=count],
.snooze-popup .repeat-right-values input[name=count],
.repeat-rule-popup .repeat-right-values input[name=count],
.repeat-options-modal .repeat-right-values input[name=count],
.jump-popup .repeat-right-values input[name=count] {
  padding: 0 0.5rem;
}
.react-modal-overlay.event-action-modal .repeat-left-values .react-select label,
.event-confirmation .repeat-left-values .react-select label,
.snooze-popup .repeat-left-values .react-select label,
.repeat-rule-popup .repeat-left-values .react-select label,
.repeat-options-modal .repeat-left-values .react-select label,
.jump-popup .repeat-left-values .react-select label {
  min-width: 4.5rem;
}
.react-modal-overlay.event-action-modal .repeat-left-values .repeat-interval-wrapper,
.event-confirmation .repeat-left-values .repeat-interval-wrapper,
.snooze-popup .repeat-left-values .repeat-interval-wrapper,
.repeat-rule-popup .repeat-left-values .repeat-interval-wrapper,
.repeat-options-modal .repeat-left-values .repeat-interval-wrapper,
.jump-popup .repeat-left-values .repeat-interval-wrapper {
  display: flex;
  flex-flow: row;
}
.react-modal-overlay.event-action-modal .repeat-left-values .repeat-interval-wrapper label,
.event-confirmation .repeat-left-values .repeat-interval-wrapper label,
.snooze-popup .repeat-left-values .repeat-interval-wrapper label,
.repeat-rule-popup .repeat-left-values .repeat-interval-wrapper label,
.repeat-options-modal .repeat-left-values .repeat-interval-wrapper label,
.jump-popup .repeat-left-values .repeat-interval-wrapper label {
  padding-top: 0.7rem;
  margin-right: 0.5rem;
  min-width: 4.5rem;
}
.react-modal-overlay.event-action-modal .repeat-left-values .repeat-interval-wrapper .repeat-interval-after-label,
.event-confirmation .repeat-left-values .repeat-interval-wrapper .repeat-interval-after-label,
.snooze-popup .repeat-left-values .repeat-interval-wrapper .repeat-interval-after-label,
.repeat-rule-popup .repeat-left-values .repeat-interval-wrapper .repeat-interval-after-label,
.repeat-options-modal .repeat-left-values .repeat-interval-wrapper .repeat-interval-after-label,
.jump-popup .repeat-left-values .repeat-interval-wrapper .repeat-interval-after-label {
  font-weight: 100;
  -webkit-font-smoothing: subpixel-antialiased;
  font-size: 1.2rem;
  color: #696969;
  padding-top: 0.7rem;
}
.react-modal-overlay.event-action-modal input[type=checkbox],
.event-confirmation input[type=checkbox],
.snooze-popup input[type=checkbox],
.repeat-rule-popup input[type=checkbox],
.repeat-options-modal input[type=checkbox],
.jump-popup input[type=checkbox] {
  position: absolute;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  height: 0.1rem;
  width: 0.1rem;
  margin: -0.1rem;
  padding: 0;
  border: 0;
}
.react-modal-overlay.event-action-modal input[type=checkbox] + label,
.event-confirmation input[type=checkbox] + label,
.snooze-popup input[type=checkbox] + label,
.repeat-rule-popup input[type=checkbox] + label,
.repeat-options-modal input[type=checkbox] + label,
.jump-popup input[type=checkbox] + label {
  padding-left: 1.5rem;
  margin-left: 0.5rem;
  height: 1.5rem;
  display: inline-block;
  line-height: 1.5rem;
  vertical-align: middle;
  cursor: pointer;
  position: relative;
  margin-bottom: 0;
}
.react-modal-overlay.event-action-modal input[type=checkbox] + label:before,
.event-confirmation input[type=checkbox] + label:before,
.snooze-popup input[type=checkbox] + label:before,
.repeat-rule-popup input[type=checkbox] + label:before,
.repeat-options-modal input[type=checkbox] + label:before,
.jump-popup input[type=checkbox] + label:before {
  content: "\\f1db";
  font-family: "FontAwesome";
  font-weight: 200;
  height: 1.5rem;
  width: 1.5rem;
  left: 0;
  position: absolute;
}
.react-modal-overlay.event-action-modal input[type=checkbox]:checked + label:before,
.event-confirmation input[type=checkbox]:checked + label:before,
.snooze-popup input[type=checkbox]:checked + label:before,
.repeat-rule-popup input[type=checkbox]:checked + label:before,
.repeat-options-modal input[type=checkbox]:checked + label:before,
.jump-popup input[type=checkbox]:checked + label:before {
  content: "\\f111";
}
.react-modal-overlay.event-action-modal input.no-margin-left[type=checkbox] + label,
.event-confirmation input.no-margin-left[type=checkbox] + label,
.snooze-popup input.no-margin-left[type=checkbox] + label,
.repeat-rule-popup input.no-margin-left[type=checkbox] + label,
.repeat-options-modal input.no-margin-left[type=checkbox] + label,
.jump-popup input.no-margin-left[type=checkbox] + label {
  margin-left: 0;
}

.event-attendees .Select-control .Select-input {
  height: 2.2rem;
  position: relative;
}
.event-attendees .Select-control .Select-input input {
  position: relative;
  bottom: 0;
  height: 2.2rem;
  padding: 0;
}
.event-attendees .Select-placeholder {
  line-height: 2em;
}
.event-attendees .react-select {
  margin-bottom: 0.3rem;
}

.attendee {
  display: flex;
  flex-flow: row nowrap;
  margin-top: 0.5rem;
}
.attendee__status {
  flex: 0 0 2rem;
  margin-right: 0.8rem;
  position: relative;
}
.attendee__status:before {
  position: absolute;
  bottom: -0.2rem;
  right: -0.6rem;
  height: 1.4rem;
  width: 1.4rem;
  content: "\\f059";
  font-family: "FontAwesome";
  background: white;
  font-size: 1.4rem;
  line-height: 1.4rem;
  border-radius: 50%;
}
.attendee__status.ACCEPTED:before {
  content: "\\f058";
  color: #2ab27b;
}
.attendee__status.DECLINED:before {
  content: "\\f057";
  color: red;
}
.attendee__status img {
  border-radius: 50%;
}
.attendee__name {
  flex: 1 1 100%;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.attendee__remove {
  flex: 0 0 2rem;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: space-around;
  cursor: pointer;
}

.change-display input[type=checkbox] {
  position: absolute;
  z-index: -1;
  opacity: 0;
}
.change-display label {
  cursor: pointer;
  margin: 0;
  font-weight: 300;
}
.change-display label::before {
  position: absolute;
  left: 0;
  top: 0 !important;
  content: "\\f058" !important;
  font: normal normal normal 14px/1 FontAwesome;
  color: #cacacb;
  font-size: 1.2em;
}
.change-display label.checked::before {
  color: #dabc64;
}
.change-display label .small {
  font-size: 1.2rem;
}`, "",{"version":3,"sources":["webpack://./src/Styles/Colors.scss","webpack://./src/Components/Pages/CreateEvent/CreateEvent.scss","webpack://./src/Styles/Material.scss"],"names":[],"mappings":"AAsCA;EACE,cArCU;ACAZ;;ACFA;EACE,gFAAA;ADKF;;ACFA;;;;;;EACE,gFAAA;ADUF;;ACPA;EACE,gBAAA;EACA,eAAA;ADUF;;AAfE;EACE,cAAA;AAkBJ;AAhBE;EACE,WAAA;AAkBJ;AAjBI;EACE,WAAA;AAmBN;AAfE;EAEE,kBAAA;AAgBJ;AAbE;EAEE,mBAAA;AAcJ;AAXE;EACE,kBAAA;AAaJ;AAVE;EACE,cAAA;EACA,gBAAA;AAYJ;AAXI;EACE,UAAA;AAaN;AATE;EAjCF;IAkCI,mBAAA;EAYF;AACF;;AAHA;;;;;;EAME,aAAA;EACA,mBAAA;EACA,6BAAA;AAMF;AAJE;;;;;;EACE,cAAA;EACA,WAAA;AAWJ;AATI;EAJF;;;;;;IAKI,iBAAA;IACA,MAAA;IACA,QAAA;IACA,gBAAA;IACA,oCAAA;IACA,YAAA;EAiBJ;AACF;AAdE;;;;;;EAEE,WAAA;EACA,6BAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,qBD7EY;ACiGhB;AAnBI;EATF;;;;;;IAUI,UAAA;IACA,YAAA;IACA,UAAA;IACA,aAAA;IACA,WAAA;IACA,YAAA;IACA,gBAAA;EA2BJ;AACF;AAzBI;;;;;;EACE,sBAAA;EACA,sBAAA;EACA,gBAAA;EACA,cD7FM;AC6HZ;AA9BM;EANF;;;;;;IAOI,iBAAA;IACA,6BAAA;EAsCN;AACF;AAnCI;;;;;;EACE,cDrGU;AC+IhB;AAxCM;;;;;;;;;;;;EAEE,gBAAA;EACA,4CAAA;AAoDR;AA/CE;;;;;;;;;;;;EAEE,mBAAA;EACA,iBAAA;EACA,cDnHY;AC8KhB;AAzDI;;;;;;;;;;;;EACE,mBAAA;AAsEN;AAlEE;;;;;;EACE,kBAAA;EACA,WAAA;EACA,SAAA;AAyEJ;AAvEI;EALF;;;;;;IAMI,WAAA;EA+EJ;AACF;AA5EE;;;;;;EACE,iBAAA;AAmFJ;AAhFE;;;;;;EACE,eAAA;EACA,gBAAA;EACA,UAAA;EACA,YAAA;AAuFJ;AApFE;;;;;;EACE,cDjJQ;AC4OZ;AAxFE;;;;;;EACE,SAAA;AA+FJ;AA5FE;;;;;;EACE,gBAAA;EACA,iBAAA;AAmGJ;AAhGE;;;;;;EACE,2BAAA;AAuGJ;AApGE;;;;;;EACE,gBAAA;AA2GJ;AAxGE;;;;;;EACE,mBAAA;AA+GJ;AA5GE;;;;;;EACE,cAAA;AAmHJ;AAhHE;;;;;;EACE,gBAAA;EACA,SAAA;EACA,aAAA;EACA,gBAAA;EACA,cDjLY;ACwShB;AApHE;;;;;;EACE,UAAA;AA2HJ;AAvHI;;;;;;EACE,iBAAA;AA8HN;AA3HI;;;;;;EACE,4BAAA;AAkIN;AA9HE;;;;;;EACE,WAAA;AAqIJ;AAjII;;;;;;EACE,kBAAA;AAwIN;AArII;;;;;;;;;;;;;;;;;;EAGE,mBAAA;AAsJN;AAnJI;;;;;;EACE,iBAAA;AA0JN;AApJM;;;;;;EACE,iBAAA;AA2JR;AAvJI;;;;;;EACE,aAAA;EACA,cAAA;AA8JN;AA5JM;;;;;;EACE,mBAAA;EACA,oBAAA;EACA,iBAAA;AAmKR;AAhKM;;;;;;EACE,gBAAA;EACA,4CAAA;EACA,iBAAA;EACA,cD3OQ;EC4OR,mBAAA;AAuKR;AAlKE;;;;;;EACE,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,cAAA;EACA,aAAA;EACA,eAAA;EACA,UAAA;EACA,SAAA;AAyKJ;AAvKI;;;;;;EACE,oBAAA;EACA,mBAAA;EACA,cAAA;EACA,qBAAA;EACA,mBAAA;EACA,sBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;AA8KN;AA5KM;;;;;;EACE,gBAAA;EACA,0BAAA;EACA,gBAAA;EACA,cAAA;EACA,aAAA;EACA,OAAA;EACA,kBAAA;AAmLR;AAhLI;;;;;;EACE,gBAAA;AAuLN;AAnLE;;;;;;EACE,cAAA;AA0LJ;;AArLE;EACE,cAAA;EACA,kBAAA;AAwLJ;AAvLI;EACE,kBAAA;EACA,SAAA;EACA,cAAA;EACA,UAAA;AAyLN;AAtLE;EACE,gBAAA;AAwLJ;AAtLE;EACE,qBAAA;AAwLJ;;AApLA;EACE,aAAA;EACA,qBAAA;EACA,kBAAA;AAuLF;AArLE;EACE,cAAA;EACA,oBAAA;EACA,kBAAA;AAuLJ;AArLI;EACE,kBAAA;EACA,eAAA;EACA,cAAA;EACA,cAAA;EACA,aAAA;EACA,gBAAA;EACA,0BAAA;EACA,iBAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;AAuLN;AApLI;EACE,gBAAA;EACA,cD1SU;ACgehB;AAnLI;EACE,gBAAA;EACA,UD7SS;ACkef;AAlLI;EACE,kBAAA;AAoLN;AAhLE;EACE,cAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;AAkLJ;AA/KE;EACE,cAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,6BAAA;EACA,eAAA;AAiLJ;;AA5KE;EACE,kBAAA;EACA,WAAA;EACA,UAAA;AA+KJ;AA5KE;EACE,eAAA;EACA,SAAA;EACA,gBAAA;AA8KJ;AA7KI;EACE,kBAAA;EACA,OAAA;EACA,iBAAA;EACA,2BAAA;EACA,6CAAA;EACA,cDrXW;ECsXX,gBAAA;AA+KN;AA7KI;EACE,cD3WC;AC0hBP;AA7KI;EACE,iBAAA;AA+KN","sourcesContent":["// Define colors here to use across the site\n\n$textColor: #292727;\n$darkTextColor: #696969;\n$lightTextColor: #cacacb;\n$black: black;\n$borderColor: #c0c0c0;\n$gridBorderColor: #ddd;\n$hoverColor: #b8b8b8;\n$shadow: #9c9c9c;\n$gray: #efefef;\n$darkGray: #515554;\n$backgroundColor: #ffffff;\n$backgroundRight: #ffffff;\n$backgroundLeft: #e9e9e9;\n$success: #18b100;\n$headingsGray: #333333;\n$camelGold: #d0ad4d;\n$gold: #dabc64;\n$iconColor: #9c9c9c;\n$navIcon: #4d4d4d;\n$navIconActive: #dabc64;\n$iconColorActive: #dabc64;\n$magenta: #ab3a72;\n$habitPrimary: rgb(51, 51, 51);\n$habitBorder: rgb(208, 213, 221);\n$habitActionText: rgb(86, 86, 86);\n$habitActionIcon: #565656;\n\n// Brands\n$brand-primary: #3097d1;\n$brand-info: #8eb4cb;\n$brand-success: #2ab27b;\n$brand-warning: #cbb956;\n$brand-danger: red;\n\n$orange: #f5a000;\n\n.gray {\n  color: $textColor;\n}\n\n$input-color: #555;\n\n$headingColor: #999;\n$dayHeadingColor: #555;\n$undoBackground: #bdbdbd;\n","@import './Variables.scss';\n@import 'Colors.scss';\n@import 'Material.scss';\n\n.event-modal {\n  .modal-header {\n    font-size: 2em;\n  }\n  .event-address {\n    width: 100%;\n    input {\n      width: 100%;\n    }\n  }\n\n  & > .row:not(:first-child),\n  & > .flex-row:not(:first-child) {\n    margin-top: 0.5rem;\n  }\n\n  & > .row:first-child,\n  & > .flex-row:first-child {\n    margin-bottom: 1rem;\n  }\n\n  label[for='description'] {\n    margin-top: 0.7rem;\n  }\n\n  .description.ql-container {\n    height: 7.5rem;\n    overflow-y: auto;\n    .ql-editor {\n      padding: 0;\n    }\n  }\n\n  @media (min-width: $tablet) {\n    min-height: 33.5rem;\n    // margin-bottom: 5.1rem;\n\n    // > .row:last-child {\n    //   position: absolute;\n    //   bottom: 0;\n    //   width: 100%;\n    // }\n  }\n}\n.react-modal-overlay.event-action-modal,\n.event-confirmation,\n.snooze-popup,\n.repeat-rule-popup,\n.repeat-options-modal,\n.jump-popup {\n  display: flex;\n  align-items: center;\n  justify-content: space-around;\n\n  span.react-modal-close {\n    height: 1.5rem;\n    right: 1rem;\n\n    @media (max-width: $tablet) {\n      font-size: 1.6rem;\n      top: 0;\n      right: 0;\n      margin-bottom: 0;\n      padding: 0.8rem 0.8rem 0.8rem 0.8rem;\n      height: 3rem;\n    }\n  }\n\n  .react-modal {\n    @extend .layered-no-overlap;\n    color: #fff;\n    padding: 0 0.5rem 2rem 0.5rem;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    border-color: $darkTextColor;\n    @media (min-width: $mobile) {\n      padding: 0;\n      width: 50rem;\n      top: unset;\n      bottom: unset;\n      left: unset;\n      right: unset;\n      max-height: 100%;\n    }\n\n    .clone-btn.btn.btn-default {\n      padding: 0.6rem 1.2rem;\n      margin: -0.6rem 0.6rem;\n      min-width: unset;\n      color: $textColor;\n\n      @media (max-width: $tablet) {\n        font-size: 1.6rem;\n        margin: 0.3rem 0.6rem -0.3rem;\n      }\n    }\n\n    .react-modal-content {\n      color: $darkTextColor;\n\n      label,\n      .label {\n        font-weight: 100;\n        -webkit-font-smoothing: subpixel-antialiased;\n      }\n    }\n  }\n\n  label,\n  .label {\n    white-space: nowrap;\n    font-size: 1.2rem;\n    color: $darkTextColor;\n\n    &.manage-alarms-label {\n      padding-top: 1.5rem;\n    }\n  }\n\n  .color-picker-wrapper {\n    position: absolute;\n    right: 1rem;\n    top: 3rem;\n\n    @media (max-width: $tablet) {\n      top: 3.6rem;\n    }\n  }\n\n  .react-select {\n    font-size: 1.2rem;\n  }\n\n  .minimal-input {\n    padding-left: 0;\n    padding-right: 0;\n    padding: 0;\n    height: auto;\n  }\n\n  .form-control {\n    color: $textColor;\n  }\n\n  .form-group {\n    margin: 0;\n  }\n\n  .event-label input {\n    margin-top: 1rem;\n    font-size: 1.8rem;\n  }\n\n  .margin-top {\n    margin-top: 2rem !important;\n  }\n\n  .half-margin-top {\n    margin-top: 1rem;\n  }\n\n  .half-margin-bottom {\n    margin-bottom: 1rem;\n  }\n\n  .no-margin-left {\n    margin-left: 0;\n  }\n\n  .btn-default {\n    min-width: 12rem;\n    border: 0;\n    background: 0;\n    border-radius: 0;\n    color: $darkTextColor;\n  }\n\n  .Select-value {\n    padding: 0;\n  }\n\n  .calendar-timezone-area {\n    label {\n      min-width: 6.5rem;\n    }\n\n    .Select-value {\n      max-width: calc(100% - 2rem);\n    }\n  }\n\n  textarea {\n    width: 100%;\n  }\n\n  .repeat-right-values {\n    .flex-row {\n      min-height: 2.1rem;\n    }\n\n    input[type='checkbox'] + label,\n    .label,\n    label {\n      line-height: 2.1rem;\n    }\n\n    input[name='count'] {\n      padding: 0 0.5rem;\n    }\n  }\n\n  .repeat-left-values {\n    .react-select {\n      label {\n        min-width: 4.5rem;\n      }\n    }\n\n    .repeat-interval-wrapper {\n      display: flex;\n      flex-flow: row;\n\n      label {\n        padding-top: 0.7rem;\n        margin-right: 0.5rem;\n        min-width: 4.5rem;\n      }\n\n      .repeat-interval-after-label {\n        font-weight: 100;\n        -webkit-font-smoothing: subpixel-antialiased;\n        font-size: 1.2rem;\n        color: $darkTextColor;\n        padding-top: 0.7rem;\n      }\n    }\n  }\n\n  input[type='checkbox'] {\n    position: absolute;\n    overflow: hidden;\n    clip: rect(0, 0, 0, 0);\n    height: 0.1rem;\n    width: 0.1rem;\n    margin: -0.1rem;\n    padding: 0;\n    border: 0;\n\n    & + label {\n      padding-left: 1.5rem;\n      margin-left: 0.5rem;\n      height: 1.5rem;\n      display: inline-block;\n      line-height: 1.5rem;\n      vertical-align: middle;\n      cursor: pointer;\n      position: relative;\n      margin-bottom: 0;\n\n      &:before {\n        content: '\\f1db';\n        font-family: 'FontAwesome';\n        font-weight: 200;\n        height: 1.5rem;\n        width: 1.5rem;\n        left: 0;\n        position: absolute;\n      }\n    }\n    &:checked + label:before {\n      content: '\\F111';\n    }\n  }\n\n  input.no-margin-left[type='checkbox'] + label {\n    margin-left: 0;\n  }\n}\n\n.event-attendees {\n  .Select-control .Select-input {\n    height: 2.2rem;\n    position: relative;\n    input {\n      position: relative;\n      bottom: 0;\n      height: 2.2rem;\n      padding: 0;\n    }\n  }\n  .Select-placeholder {\n    line-height: 2em;\n  }\n  .react-select {\n    margin-bottom: 0.3rem;\n  }\n}\n\n.attendee {\n  display: flex;\n  flex-flow: row nowrap;\n  margin-top: 0.5rem;\n\n  &__status {\n    flex: 0 0 2rem;\n    margin-right: 0.8rem;\n    position: relative;\n\n    &:before {\n      position: absolute;\n      bottom: -0.2rem;\n      right: -0.6rem;\n      height: 1.4rem;\n      width: 1.4rem;\n      content: '\\f059';\n      font-family: 'FontAwesome';\n      background: white;\n      font-size: 1.4rem;\n      line-height: 1.4rem;\n      border-radius: 50%;\n    }\n\n    &.ACCEPTED:before {\n      content: '\\f058';\n      color: $brand-success;\n    }\n\n    &.DECLINED:before {\n      content: '\\f057';\n      color: $brand-danger;\n    }\n\n    img {\n      border-radius: 50%;\n    }\n  }\n\n  &__name {\n    flex: 1 1 100%;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    overflow: hidden;\n  }\n\n  &__remove {\n    flex: 0 0 2rem;\n    text-align: center;\n    display: flex;\n    align-items: center;\n    justify-content: space-around;\n    cursor: pointer;\n  }\n}\n\n.change-display {\n  input[type='checkbox'] {\n    position: absolute;\n    z-index: -1;\n    opacity: 0;\n  }\n\n  label {\n    cursor: pointer;\n    margin: 0;\n    font-weight: 300;\n    &::before {\n      position: absolute;\n      left: 0;\n      top: 0 !important;\n      content: '\\f058' !important;\n      font: normal normal normal 14px/1 FontAwesome;\n      color: $lightTextColor;\n      font-size: 1.2em;\n    }\n    &.checked::before {\n      color: $gold;\n    }\n    .small {\n      font-size: 1.2rem;\n    }\n  }\n}\n",".layered {\n  box-shadow: 0 1rem 2rem rgba(0, 0, 0, 0.19), 0 0.6rem 0.6rem rgba(0, 0, 0, 0.23);\n}\n\n.layered-no-overlap {\n  box-shadow: 0 1rem 1rem rgba(0, 0, 0, 0.19), 0 0.6rem 0.6rem rgba(0, 0, 0, 0.23);\n}\n\n.no-gutter > [class*='col-'] {\n  padding-right: 0;\n  padding-left: 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
